import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { smartSalesPortalUrl } from 'app.constants';
export class SmartSalesController {
    static $inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
    constructor(LoadingService, TranslateService, application, AccountService2) {
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.application = application;
        this.AccountService2 = AccountService2;
        LoadingService.startLoading();
        const setProps = async () => {
            const account = await this.AccountService2.me();
            const userEmail = encodeURIComponent(account.email);
            const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = useDelegation
                ? `${userEmail}/${this.application.shortName}`
                : this.application.shortName;
            this.LoadingService.stopLoading();
        };
        this.smartSalesUrl = smartSalesPortalUrl;
        setProps();
    }
}
SmartSalesController.$inject = ['LoadingService', 'TranslateService', 'application', 'AccountService2'];
